import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=e863725e&scoped=true"
import script from "./AlertDetail.vue?vue&type=script&lang=js"
export * from "./AlertDetail.vue?vue&type=script&lang=js"
import style0 from "./AlertDetail.vue?vue&type=style&index=0&id=e863725e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e863725e",
  null
  
)

export default component.exports